import React from 'react';

import { Icon, IconProps } from '../../icon';
export const WalletPictogram = ({ ...props }: IconProps) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6.96667C4 5.32822 5.32822 4 6.96667 4H18V6.6H6.96667C6.76416 6.6 6.6 6.76416 6.6 6.96667V41.0333C6.6 41.2359 6.76416 41.4 6.96667 41.4H18V44H6.96667C5.32822 44 4 42.6718 4 41.0333V6.96667ZM44 6.96667C44 5.32822 42.6718 4 41.0333 4H30V6.6H41.0333C41.2358 6.6 41.4 6.76416 41.4 6.96667V41.0333C41.4 41.2359 41.2358 41.4 41.0333 41.4H30V44H41.0333C42.6718 44 44 42.6718 44 41.0333V6.96667ZM24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z"
        fill="currentColor"
      />
    </Icon>
  );
};
